<template>
    <FormViewTemplate
      :backButtonRoute="'/settings/products'"
      :dataModel="dataModel"
      :pageData="pageData"
      :toolbarOptions="toolbarOptions"
      :formItems="setFormItems"
      :saveModel="model"
      :formContentReady="formContentReady"
    />
</template>


<script>
import FormViewTemplate from "../../../templates/form-view";
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import ApiService from '../../../_services/api/api.service';

export default {
  props: {},
  components: { FormViewTemplate },
  mixins: [RouteMixin, FormMixin],
  data(){
    return {
      pageData: {
        route: "/category-labels",
        name: "Category Labels",
        saveEndpoint: "Save_CategoryLabels",
        local: true,
        createTitle: "Category Labels"
      },
      model: {
        PRODCAT1: "",
        PRODCAT2: "",
        PRODCAT3: "",
        PRODCAT4: "",
        Product_Type: "",
        Product_Size: "",
      },
      dataModel: {
        Name: "Category Labels"
      },
      formOptions: {
        gcLabelLocation: "left",
      },
      toolbarOptions: {
        save: true,
        header: true,
      }
    }
  },
  async created() {
    await ApiService.get("api/UserTableReference").then((res) => {
      res.data.value.forEach((item) => {
        switch (item.TableName) {
          case 'PRODCAT1':
            this.model.PRODCAT1 = item.FieldLabel;
            break;
          case 'PRODCAT2':
            this.model.PRODCAT2 = item.FieldLabel;
            break;
          case 'PRODCAT3':
            this.model.PRODCAT3 = item.FieldLabel;
            break;
          case 'PRODCAT4':
            this.model.PRODCAT4 = item.FieldLabel;
            break;
          case 'Product_Type':
            this.model.Product_Type = item.FieldLabel;
            break;
          case 'Product_Size':
            this.model.Product_Size = item.FieldLabel;
            break;
          default:
            break;
        }
      })
    });

    this.dataModel = {...this.model, ...this.dataModel}
  },
  methods: {
    formContentReady(e){
      if(this.baseView.mode == 'edit'){
        setTimeout(() => {
          e.component.getEditor("PRODCAT1").focus();
        }, 1);

      }
    }
  },
  computed: {
    setFormItems() {
      var items = [
        {
          itemType: "group",
          caption: "",
          colCount: 2,
          items: [
            {
              itemType: "group",
              caption: "",
              colCount: 1,
              items: [
                {
                  dataField: "PRODCAT1",
                  required: true,
                  label: {
                    text: "Category 1"
                  },
                  editorOptions: {
                    onFocusIn: (e) => {
                      e.event.target.select();
                    },
                  }
                },
                {
                  dataField: "PRODCAT2",
                  required: true,
                  label: {
                    text: "Category 2"
                  },
                  editorOptions: {
                    onFocusIn: (e)=>{
                      e.event.target.select();
                    },
                  }
                },
                {
                  dataField: "PRODCAT3",
                  required: true,
                  label: {
                    text: "Category 3"
                  },
                  editorOptions: {
                    onFocusIn: (e)=>{
                      e.event.target.select();
                    },
                  }
                },
                {
                  dataField: "PRODCAT4",
                  required: true,
                  label: {
                    text: "Category 4"
                  },
                  editorOptions: {
                    onFocusIn: (e)=>{
                      e.event.target.select();
                    },
                  }
                },
                {
                  dataField: "Product_Type",
                  required: true,
                  label: {
                    text: "Product Type"
                  },
                  editorOptions: {
                    onFocusIn: (e)=>{
                      e.event.target.select();
                    },
                  }
                },
                {
                  dataField: "Product_Size",
                  required: true,
                  label: {
                    text: "Product Size"
                  },
                  editorOptions: {
                    onFocusIn: (e)=>{
                      e.event.target.select();
                    },
                  }
                },
              ]
            }
          ]
        }
      ];
      return items;
    }
  }
}
</script>